<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formating
	import { format } from '../../../../services/i18n';
	//Stores
		import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Design system components
	import { Button, Toggle, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device: Device;

	let checked = $settingsStore?.blugw?.sys_led_enable;
	let waitForResponse = false;

	const saveValue = async () => {
		waitForResponse = true;
		const res: SettingRequest = await gen2Request(device, 'blugw.setconfig', {
			id: 0,
			config: { sys_led_enable: checked },
		});
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	const toggleValue = async () => {
		if (waitForResponse) return;
		checked = !checked;
		if ($showNewLayout) {
			await saveValue();
		}
	};
</script>

<Text class=" mb-s"
	>{$format('text_blu_gateway_enable_disable_led', {
		default: "Enable or disable BLU Gateway's system LED",
	})}</Text
>

<Toggle
	size="m"
	class="mb-s"
	{checked}
	on:click={toggleValue}
	disabled={waitForResponse}
	id="toggle-5k7dtf9"
>
	{$format('enable', {
		default: 'Enable',
	})}
</Toggle>
{#if !$showNewLayout}
	<Button loading={waitForResponse} size="m" width="full" class="mb-s" on:click={saveValue}
		>{$format('button_save')}</Button
	>
{/if}
